import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 19h10V4H7v15zM9 6h6v11H9V6zM3 6h2v11H3zM19 6h2v11h-2z"
}), 'AmpStoriesOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AmpStoriesOutlined.js
// module id = 2038
// module chunks = 2